import { url_servicios } from 'app/domain/publico';
import { Usuario } from 'app/domain/usuario';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
declare var $: any;

@Injectable()
export class DashboardService {
    constructor(private http: Http, private router: Router) {
        var headers = new Headers();
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("key_apm"));
        this.options = new RequestOptions({ headers: headers });

        this.usuario = JSON.parse(localStorage.getItem("usuario"));
    }

    usuario: Usuario;
    options;


    get_cuadros(finicio, ffin) {
        var method = "dashboard/cuadro?ruc=" + this.usuario.rucEmpresa + "&usuario=" + this.usuario.usuarioCuenta;

        //if ((finicio && ffin) != '')
        method += "&fechainicio=" + finicio + "&fechafin=" + ffin;

        return this.HTTPGET(method)
    }

    get_grafico(finicio, ffin) {
        var method = "dashboard/grafico?ruc=" + this.usuario.rucEmpresa + "&usuario=" + this.usuario.usuarioCuenta;

        //if ((finicio && ffin) != '')
        method += "&fechainicio=" + finicio + "&fechafin=" + ffin;

        return this.HTTPGET(method);
    }

    /**
 * METODOS HTTP
 */

    private HTTPGET(method) {

        return this.http.get(url_servicios + method, this.options)
            .map(resp => resp.json())
            .catch(error => this.ERROR(error));
    }

    private ERROR(e: any) {
        switch (e.status) {
            case 400:
                return Observable.throw(JSON.parse(e._body).message);
            case 401:
                window.localStorage.removeItem("cse_technology");
                window.localStorage.removeItem("cse_modality");
                window.localStorage.removeItem("key_apm");
                window.localStorage.removeItem("usuario");
                this.router.navigate(['/iniciar-sesion']);
                $('#expires').html(
                    '<div class="alert alert-danger" id= "expires" >' +
                    "Sesion ha expirado ..." +
                    '</div>'
                );
                return Observable.throw("Sesion ha expirado, Cerrrando sesion ...");
            case 500:
                return Observable.throw("Internal Server Error");
            default:
                return Observable.throw("Ocurrio un error");
        }
    }


}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/services/dashboard.service.ts